import React, { useState } from "react";
import { connect } from "react-redux";
import { Box, Button, CircularProgress, Divider } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { LeftSidebar as NavFrame } from "layout-blueprints";
import StandardHeader from "../../components/global/StandardHeader";
import CombinedBoard from "./CombinedBoard";
import NewMoveDialog from "./NewMoveDialog";

// The moves dashboard is the combined board: move-ins and move-outs together, with what the batch's next run
// will do with each one.
function MoveInsOutsPage(props) {
  const [newMove, setNewMove] = useState(null);
  const details = props.user?.details;
  const canView = Boolean(details && (details.billing || details.administration || details.isSuperUser));

  if (!details) {
    return (
      <NavFrame page="Moves Dashboard">
        <StandardHeader title="Moves Dashboard" />
        <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
          <CircularProgress />
        </Box>
      </NavFrame>
    );
  }

  if (!canView) {
    return (
      <NavFrame page="Moves Dashboard">
        <StandardHeader title="Moves Dashboard" />
        <Divider className="mb-3 mt-3" />
        <h3>You do not have privileges for the moves dashboard</h3>
      </NavFrame>
    );
  }

  return (
    <NavFrame page="Moves Dashboard">
      <StandardHeader title="Moves Dashboard" />
      <Divider className="mb-3 mt-3" />

      <NewMoveDialog open={Boolean(newMove)} initialKind={newMove || "in"} onClose={() => setNewMove(null)} />

      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mb: 2 }}>
        <Button size="small" variant="outlined" color="inherit" component={RouterLink} to="/move-ins-outs/processed" sx={{ textTransform: "none", color: "text.secondary", borderColor: "divider" }}>Processed moves</Button>
        <Button size="small" variant="outlined" color="inherit" component={RouterLink} to="/move-ins-outs/deleted" sx={{ textTransform: "none", mr: "auto", color: "text.secondary", borderColor: "divider" }}>Deleted moves</Button>
        <Button size="small" variant="outlined" onClick={() => setNewMove("in")} sx={{ textTransform: "none" }}>+ New move-in</Button>
        <Button size="small" variant="outlined" onClick={() => setNewMove("out")} sx={{ textTransform: "none" }}>+ New move-out</Button>
      </Box>

      <CombinedBoard />
    </NavFrame>
  );
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default connect(mapStateToProps)(MoveInsOutsPage);
